import { translateObjectData } from '../../utils/locale';
import { applyVAT } from '../../utils/string';

const listAnalytics = (items, setup, currentView) => {
	if (typeof window === 'undefined') return;
	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	window.dataLayer.push({
		event: 'view_item_list',
		ecommerce: {
			items: items.map((item, i) => {
				const localizedItem = translateObjectData(setup, item);
				const itemCategory = localizedItem.canonicalUri.split('/').slice(0, -1).reduce((acc, category, j) => ({ ...acc, [`item_category${j > 0 ? j + 1 : ''}`]: category }), {});
				return {
					item_name: localizedItem.name,
					item_id: localizedItem.variantId,
					price: applyVAT(setup, localizedItem.price, false, 5),
					item_brand: localizedItem.brand,
					...itemCategory,
					item_variant: localizedItem.variant,
					item_list_name: currentView,
					index: i + 1,
					quantity: '1',
				};
			}),
		},
	});
};

export default listAnalytics;
